import React from 'react';
import Typography from '@material-ui/core/Typography';
import RichTextRenderer from '../common/RichTextRenderer';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const ExpandingText = ({text, label, labelVariant = 'h6'}) => {
    return <ExpansionPanel>
        <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon/>}
            aria-controls='introduction'
            id='introduction'
        >
            <Typography variant={labelVariant}>{label}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
            <RichTextRenderer text={text}/>
        </ExpansionPanelDetails>
    </ExpansionPanel>
};

export default ExpandingText;